import axios from 'axios';

// Built-in fallback database for when API is unavailable
export const FALLBACK_EXERCISES = [
  { id: 1, name: 'Push-Up', bodyPart: 'chest', equipment: 'body weight', target: 'pectorals', gifUrl: null, instructions: ['Start in plank position', 'Lower chest to floor', 'Push back up'] },
  { id: 2, name: 'Squat', bodyPart: 'upper legs', equipment: 'body weight', target: 'quads', gifUrl: null, instructions: ['Stand feet shoulder width', 'Lower until thighs parallel', 'Drive back up'] },
  { id: 3, name: 'Deadlift', bodyPart: 'back', equipment: 'barbell', target: 'spine', gifUrl: null, instructions: ['Stand over bar', 'Hinge at hips', 'Drive hips forward to stand'] },
  { id: 4, name: 'Bench Press', bodyPart: 'chest', equipment: 'barbell', target: 'pectorals', gifUrl: null, instructions: ['Lie on bench', 'Grip bar slightly wider than shoulders', 'Lower to chest, press up'] },
  { id: 5, name: 'Pull-Up', bodyPart: 'back', equipment: 'body weight', target: 'lats', gifUrl: null, instructions: ['Hang from bar', 'Pull until chin over bar', 'Lower controlled'] },
  { id: 6, name: 'Plank', bodyPart: 'waist', equipment: 'body weight', target: 'abs', gifUrl: null, instructions: ['Forearms on floor', 'Body straight line', 'Hold position'] },
  { id: 7, name: 'Lunges', bodyPart: 'upper legs', equipment: 'body weight', target: 'quads', gifUrl: null, instructions: ['Step forward', 'Lower back knee toward floor', 'Return to start'] },
  { id: 8, name: 'Dumbbell Curl', bodyPart: 'upper arms', equipment: 'dumbbell', target: 'biceps', gifUrl: null, instructions: ['Hold dumbbells at sides', 'Curl up to shoulders', 'Lower controlled'] },
  { id: 9, name: 'Tricep Dip', bodyPart: 'upper arms', equipment: 'body weight', target: 'triceps', gifUrl: null, instructions: ['Hands on bench behind', 'Lower body down', 'Press back up'] },
  { id: 10, name: 'Mountain Climbers', bodyPart: 'waist', equipment: 'body weight', target: 'abs', gifUrl: null, instructions: ['Start in plank', 'Drive knees to chest alternating', 'Keep hips down'] },
  { id: 11, name: 'Shoulder Press', bodyPart: 'shoulders', equipment: 'dumbbell', target: 'delts', gifUrl: null, instructions: ['Hold dumbbells at shoulder height', 'Press overhead', 'Lower slowly'] },
  { id: 12, name: 'Romanian Deadlift', bodyPart: 'upper legs', equipment: 'barbell', target: 'hamstrings', gifUrl: null, instructions: ['Hold bar at hips', 'Hinge forward keeping back flat', 'Return to standing'] },
  { id: 13, name: 'Lat Pulldown', bodyPart: 'back', equipment: 'cable', target: 'lats', gifUrl: null, instructions: ['Grip bar wide', 'Pull to upper chest', 'Control the return'] },
  { id: 14, name: 'Leg Press', bodyPart: 'upper legs', equipment: 'leverage machine', target: 'quads', gifUrl: null, instructions: ['Sit in machine', 'Push plate away', 'Return controlled'] },
  { id: 15, name: 'Calf Raise', bodyPart: 'lower legs', equipment: 'body weight', target: 'calves', gifUrl: null, instructions: ['Stand on edge of step', 'Rise up on toes', 'Lower heel below step'] },
  { id: 16, name: 'Burpee', bodyPart: 'cardio', equipment: 'body weight', target: 'cardiovascular system', gifUrl: null, instructions: ['From standing drop to floor', 'Push up', 'Jump back to feet and jump up'] },
  { id: 17, name: 'Jumping Jacks', bodyPart: 'cardio', equipment: 'body weight', target: 'cardiovascular system', gifUrl: null, instructions: ['Start standing feet together', 'Jump feet out and raise arms', 'Return to start'] },
  { id: 18, name: 'Seated Row', bodyPart: 'back', equipment: 'cable', target: 'traps', gifUrl: null, instructions: ['Sit at cable machine', 'Pull handles to abdomen', 'Squeeze shoulder blades'] },
  { id: 19, name: 'Face Pull', bodyPart: 'shoulders', equipment: 'cable', target: 'delts', gifUrl: null, instructions: ['Set cable at face height', 'Pull toward face', 'Flare elbows out'] },
  { id: 20, name: 'Hip Thrust', bodyPart: 'upper legs', equipment: 'barbell', target: 'glutes', gifUrl: null, instructions: ['Shoulders on bench', 'Bar across hips', 'Drive hips to ceiling'] },
];

export const BODY_PARTS = ['all', 'back', 'cardio', 'chest', 'lower arms', 'lower legs', 'neck', 'shoulders', 'upper arms', 'upper legs', 'waist'];
export const EQUIPMENT_TYPES = ['all', 'body weight', 'barbell', 'dumbbell', 'cable', 'machine', 'resistance band', 'kettlebell', 'leverage machine'];

const API_BASE = 'https://exercisedb.p.rapidapi.com';
const API_KEY = process.env.REACT_APP_EXERCISEDB_API_KEY;

const headers = {
  'X-RapidAPI-Key': API_KEY,
  'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com',
};

export const fetchExercises = async (bodyPart = 'all', limit = 50) => {
  if (!API_KEY || API_KEY === 'your_exercisedb_rapidapi_key') {
    return FALLBACK_EXERCISES;
  }
  try {
    const url = bodyPart === 'all'
      ? `${API_BASE}/exercises?limit=${limit}`
      : `${API_BASE}/exercises/bodyPart/${bodyPart}?limit=${limit}`;
    const res = await axios.get(url, { headers });
    return res.data;
  } catch {
    return FALLBACK_EXERCISES;
  }
};

export const searchExercises = async (query) => {
  if (!API_KEY || API_KEY === 'your_exercisedb_rapidapi_key') {
    return FALLBACK_EXERCISES.filter(e =>
      e.name.toLowerCase().includes(query.toLowerCase()) ||
      e.bodyPart.toLowerCase().includes(query.toLowerCase()) ||
      e.equipment.toLowerCase().includes(query.toLowerCase())
    );
  }
  try {
    const res = await axios.get(`${API_BASE}/exercises/name/${query}`, { headers });
    return res.data;
  } catch {
    return FALLBACK_EXERCISES.filter(e =>
      e.name.toLowerCase().includes(query.toLowerCase())
    );
  }
};
